window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.dsgvo-youtube').length) {
    import('./_VideoDsgvo').then((module) => {
      module.Init();
    });
  }
  if (document.querySelectorAll('.dsgvo-vimeo').length) {
    import('./_VideoDsgvo').then((module) => {
      module.Init();
    });
  }
});

export default {};
